import { useMemo } from 'react';

import { EditAgencyInputs } from '../components/EditAgencyInputs';

import { AgencyShortDataModel } from 'src/types';

export const useAgencyAdapterAgencyDataModelToFormData = (agency: AgencyShortDataModel) => {
  const agencyDataForm: EditAgencyInputs = useMemo(() => {
    return {
      ...agency,
      name: agency.name,
      lat: agency.lat,
      lang: agency.lang,
      tel: agency.tel,
      email: agency.email,
      city: agency.city?.id,
      address: agency.address,
      currency: agency.currency,
    };
  }, [agency]);

  return {
    agencyDataForm,
  };
};
